'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dRules$002dPage$0024 from "./presto.-List-Rules-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002485 from "./presto.-Presto-Router$$anon$85.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$84() {
  this.bnm = null;
  this.bne = null;
  this.bnf = false;
  this.bnn = null;
  this.bno = false;
  this.bnr = null;
  this.bnk = null;
  this.bnl = false;
  this.bng = null;
  this.bnh = false;
  this.bni = null;
  this.bnj = false;
  this.bnp = false;
  this.bnq = false;
  this.bnm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bnr = "ListRulesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$84 as $c_Lpresto_PrestoRouter$$anon$84 };
$p = $c_Lpresto_PrestoRouter$$anon$84.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$84;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$84() {
}
export { $h_Lpresto_PrestoRouter$$anon$84 as $h_Lpresto_PrestoRouter$$anon$84 };
$h_Lpresto_PrestoRouter$$anon$84.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bnm;
});
$p.M = (function() {
  if ((!this.bnf)) {
    this.bne = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bnf = true;
  }
  return this.bne;
});
$p.O = (function() {
  if ((!this.bno)) {
    this.bnn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bno = true;
  }
  return this.bnn;
});
$p.E = (function() {
  return this.bnr;
});
$p.t = (function() {
  if ((!this.bnl)) {
    this.bnk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bnl = true;
  }
  return this.bnk;
});
$p.N = (function() {
  if ((!this.bnh)) {
    this.bng = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bnh = true;
  }
  return this.bng;
});
$p.Q = (function() {
  if ((!this.bnj)) {
    this.bni = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002485.$c_Lpresto_PrestoRouter$$anon$85();
    this.bnj = true;
  }
  return this.bni;
});
$p.v = (function() {
  if ((!this.bnq)) {
    this.bnp = false;
    this.bnq = true;
  }
  return this.bnp;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee549) => ((p) => \u03b4scrutinee549))($j_presto$002e$002dList$002dRules$002dPage$0024.$m_Lpresto_ListRulesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$84 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$84, "presto.PrestoRouter$$anon$84", ({
  P2: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$84 as $d_Lpresto_PrestoRouter$$anon$84 };
//# sourceMappingURL=presto.-Presto-Router$$anon$84.js.map
